// Auth / profile API helpers
import { api } from "./client";

export const getMe = () => api.get("/auth/me");
export const updateProfile = (data) => api.put("/auth/me", data);
export const changePassword = (data) => api.post("/auth/change-password", data);

// Which social logins are usable right now (public). Lets the login page hide a
// button instead of offering one that 503s. Booleans only — no credentials.
export const getAuthProviders = () => api.get("/auth/providers");

// Tester invitations (public — token-based)
export const getInvite = (token) => api.get(`/auth/invite/${encodeURIComponent(token)}`);
export const acceptInvite = (data) => api.post("/auth/accept-invite", data);

// Two-factor authentication (TOTP + single-use backup codes).
//
// The secret and the backup codes come back from setup/enable exactly once and
// are never retrievable again — nothing here caches or re-requests them, and
// `status` deliberately returns only a COUNT of unused codes.
export const twofaStatus = () => api.get("/auth/2fa/status");
// The password re-authenticates before a secret is issued; without it anyone
// with a borrowed session could bind their own authenticator to the account.
export const twofaSetup = (password) => api.post("/auth/2fa/setup", { password });
export const twofaEnable = (code) => api.post("/auth/2fa/enable", { code });
export const twofaDisable = (password, code) => api.post("/auth/2fa/disable", { password, code });
export const twofaRegenerateBackupCodes = (password) =>
  api.post("/auth/2fa/backup-codes/regenerate", { password });

// Account recovery — clears someone ELSE's second factor when they've lost both
// their device and their codes. Company owner scope; the superadmin equivalent
// lives in api/admin.js.
export const resetMemberTwofa = (memberId, password) =>
  api.post(`/company/team/${encodeURIComponent(memberId)}/2fa/reset`, { password });

// Password reset (public — token-based)
export const requestPasswordReset = (email) => api.post("/auth/forgot-password", { email });
export const checkPasswordReset = (token) => api.get(`/auth/reset-password/${encodeURIComponent(token)}`);
export const resetPassword = (data) => api.post("/auth/reset-password", data);
